import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[500px] md:h-[650px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20movie%20theater%20interior%20with%20red%20velvet%20curtains%20and%20golden%20decorative%20elements%2C%20dramatic%20spotlight%20on%20stage%2C%20elegant%20vintage%20cinema%20aesthetic%2C%20deep%20shadows%20and%20warm%20golden%20accents%2C%20atmospheric%20moody%20lighting&width=1920&height=1080&seq=hero-bg-niuniu&orientation=landscape"
        alt="牛牛影视 - 高清影视在线观看平台"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-background-50"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto text-center px-4">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading text-white mb-4 leading-tight">
          牛牛影视
        </h1>
        <p className="text-base md:text-lg text-foreground-200 max-w-2xl mx-auto mb-8 leading-relaxed">
          聚合海量电影、电视剧、综艺节目，覆盖牛牛电影大全与牛牛剧集，<br className="hidden md:block" />
          支持高清不缓冲在线观看，每日更新最新影视资源，一站式满足追剧观影需求。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/movie"
            className="px-8 py-3 bg-primary-500 text-background-950 rounded-lg font-semibold text-sm whitespace-nowrap hover:bg-primary-400 transition-colors cursor-pointer"
          >
            <i className="ri-movie-line mr-2"></i>
            浏览电影
          </Link>
          <Link
            to="/category/tv"
            className="px-8 py-3 border border-foreground-300/40 text-white rounded-lg font-semibold text-sm whitespace-nowrap hover:bg-white/10 transition-colors cursor-pointer"
          >
            <i className="ri-tv-line mr-2"></i>
            热门剧集
          </Link>
        </div>

        <div className="mt-10 flex items-center justify-center gap-6 flex-wrap">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="flex flex-col items-center gap-1.5 cursor-pointer group"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 rounded-xl bg-white/10 backdrop-blur-sm flex items-center justify-center group-hover:bg-primary-500/30 transition-colors">
                <i className={`${cat.icon} text-xl md:text-2xl text-white`}></i>
              </div>
              <span className="text-xs text-foreground-300 group-hover:text-white transition-colors whitespace-nowrap">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}